import { toast } from "sonner";

// One share helper for every deck surface. Opens the phone's NATIVE share
// sheet (Messages, email, WhatsApp, anything installed) via the Web Share
// API; desktop browsers without it fall back to copying the listing link.
export async function shareListing(listing) {
  if (!listing) return;
  // WHY: build the link from the CURRENT origin so shares work on staging
  // and local dev too, not just production. Only fall back to the canonical
  // domain when there is no shareable http(s) origin (file:// or blob: pages
  // report an opaque "null" origin).
  const origin = /^https?:\/\//.test(window.location.origin)
    ? window.location.origin
    : "https://swiprent.com";
  const url = `${origin}/listing/${listing.id}`;
  const text = `Check out this home on SwipRent: ${listing.title}`;
  if (navigator.share) {
    try {
      await navigator.share({ title: "SwipRent", text, url });
    } catch {
      /* user closed the sheet — not an error */
    }
    return;
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied. Paste it anywhere to share.");
  } catch {
    toast.info(url);
  }
}
